import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PushService {
  vapidPublicKey = 'YOUR_VAPID_PUBLIC_KEY';

  async init() {
    if (!('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlBase64ToUint8Array(this.vapidPublicKey)
    });

    await fetch('/api/push/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(sub)
    });
  }

  urlBase64ToUint8Array(key: string) {
    const cleaned = key.trim().replace(/[\n\r\s]/g, '');
  
    const padding = '='.repeat((4 - cleaned.length % 4) % 4);
    const base64 = (cleaned + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
  
    const raw = atob(base64);
    return Uint8Array.from(raw, c => c.charCodeAt(0));
  }

  async showTestNotification() {
    if (!('serviceWorker' in navigator)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const reg = await navigator.serviceWorker.ready;
    reg.active?.postMessage({ type: 'SHOW_NOTIFICATION' });
  }
}
